import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resource-load"
export default class extends Controller {

  // contentContainerId - data-content-container-id
  // path - data-path
  loadExternalHtml(event) {
    const path = event.target.dataset.path;
    const contentContainerId = event.target.dataset.contentContainerId;
    const contentContainer = document.getElementById(contentContainerId);

    fetch(path)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }
        return response.text();
      })
      .then(html => {
        contentContainer.innerHTML = html;
      })
      .catch(error => {
        if (contentContainer) {
          contentContainer.innerHTML = `<div class="error">Failed to load content: ${error.message}</div>`;
        }
      });
  }
}
